import { render, staticRenderFns } from "./MyAccountDownloadDetails.vue?vue&type=template&id=13384fc6&scoped=true"
import script from "./MyAccountDownloadDetails.vue?vue&type=script&lang=js"
export * from "./MyAccountDownloadDetails.vue?vue&type=script&lang=js"
import style0 from "./MyAccountDownloadDetails.vue?vue&type=style&index=0&id=13384fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13384fc6",
  null
  
)

export default component.exports